import React from 'react';
import { Input, Row, Col } from 'antd';

const RoleSearch = ({ roleData, searchText, setSearchText, setFilteredData }) => {
  const handleSearch = (value) => {
    setSearchText(value);

    const filtered = roleData.filter((record) => {
      const matchesName = record.name?.toLowerCase().includes(value.toLowerCase());
      const matchesDescription = record.description?.toLowerCase().includes(value.toLowerCase());

      return (
        matchesName || 
        matchesDescription
      );
    });

    setFilteredData(filtered); 
  };

  const handleReset = () => {
    setSearchText(''); 
    setFilteredData(roleData);
  };

  return (
    <Row justify="start" style={{ marginBottom: 16 }}>
      <Col>
        <Input.Search
          className="search-table"
          placeholder="Buscar Roles"
          value={searchText}
          onChange={(e) => handleSearch(e.target.value)}
          onSearch={handleSearch}
          allowClear
        />
      </Col>
    </Row>
  );
};

export default RoleSearch;